/*@flow*/
import history from 'lib/history';
import nested from 'lib/nested';

export default function getBboxFromQuery(): any {
  const query = history.getQuery();
  return nested(query, 'filter.bbox', '');
}
